import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { getQuotaBillingSource, sendQuotaGa } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import { getTariffsList } from 'reactApp/sections/QuotaLanding/TariffsPlans/TariffsPlans.selectors';
import { RootState } from 'reactApp/store';
import { ITariffsByTab } from 'reactApp/ui/TariffSectionNew/TariffsSection.types';
/**
 * Хук покупки рекомендованного тарифа "Единой квоты"
 * Используется в чистилке как тариф по умолчанию
 */
export const useBuyCleanerTariff = (): {
    tariffId?: string;
    tariffPrice?: number;
    tariffValue?: string;
    onBuy: () => void;
} => {
    const dispatch = useDispatch();
    const tariffList = useSelector((state: RootState) => getTariffsList(state, ''));

    const recommendedTariff: Partial<ITariffsByTab> = useMemo(() => {
        return (tariffList as ITariffsByTab[])?.find((tariff) => tariff.isRecommended && tariff.products.monthProduct) || {};
    }, [tariffList]);

    const { id, price, space } = recommendedTariff?.products?.monthProduct || {};

    const onSuccess = useCallback(() => {
        sendQuotaGa({ action: 'tariff', label: 'buy', tariff: id, amount: price });
    }, [id, price]);

    const onBuy = useCallback(() => {
        dispatch(openTariffBuy({ productId: id, source: getQuotaBillingSource(), onSuccess }));
    }, [dispatch, id, onSuccess]);

    return {
        tariffId: id,
        tariffPrice: price,
        tariffValue: space?.value,
        onBuy,
    };
};
